import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext"; // Adjust the path as necessary
import "./EmployeeLogin.css";

const EmployeeLogin = () => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false); // New state for loading indication
  const { login, isLoggedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/employee-dashboard");
    }
  }, [isLoggedIn, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true); // Indicate loading
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/employee/login`,
        { user_id: userId, password: password },
        { withCredentials: true }
      );
      if (response.data) {
        login(response.data.mobileNumber, "employee");
        navigate("/employee-dashboard");
      }
    } catch (error) {
      setError("Failed to login. Please check your credentials.");
      console.error("Login error", error);
    }
    setIsLoading(false); // Reset loading state
  };

  return (
    <div className="employee-login-container">
      {/* Optional: Add a logo or a heading here */}
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Employee Login</h2>
        <input
          type="text"
          placeholder="User ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <div className="login-error">{error}</div>}
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
};

export default EmployeeLogin;
